"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var WebFont = require("webfontloader");
var FooterComponent = /** @class */ (function () {
    function FooterComponent(mainService) {
        this.mainService = mainService;
    }
    FooterComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        //    throw new Error("Method not implemented.");
        WebFont.load({
            google: { families: ['Material Icons', 'Material Icons Outline'], },
            fontactive: function (familyName, fvd) {
                if (familyName = "Material Icons") {
                    _this.mainService.aplicationIsReady = true;
                }
            },
        });
    };
    return FooterComponent;
}());
exports.FooterComponent = FooterComponent;
